/**
 * Persisted flag key for the one-time native iOS summary intro screens.
 * Must outlive logout: it is explicitly preserved across `Preferences.clear()`
 * in the auth context's session-end handler so the intro is never re-shown.
 */
export const INTRO_SCREENS_SEEN_KEY = 'NATIVE_IOS_SUMMARY_INTRO_SEEN';
